import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const CoinIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 16 16"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M4.66634 1.00033L3.66634 2.66699L3.33301 3.33366L2.66634 5.33366L2.33301 8.66699L2.99967 11.667L3.99967 14.3337L5.84698 15.3337H9.66634L11.333 14.667L12.6663 12.667L13.333 9.33366L12.9997 5.33366L11.9997 2.66699L10.6663 0.666992H8.33301H5.99967L4.66634 1.00033Z"
        fill={getColor(secondaryColor)}
      />
      <path
        d="M12.812 13.6843C13.589 12.2036 14 10.2379 14 8C14 5.76214 13.589 3.79643 12.812 2.31571C12.035 0.835 10.9415 -1.33691e-07 9.8 -1.83588e-07L6.2 -3.40949e-07C5.0585 -3.90845e-07 3.96125 0.844285 3.188 2.31571C2.41475 3.78714 2 5.76214 2 8C2 10.2379 2.411 12.2036 3.188 13.6843C3.965 15.165 5.0585 16 6.2 16L9.8 16C10.9415 16 12.0387 15.1557 12.812 13.6843ZM12.8 8C12.8 12.4743 11.0577 14.8571 9.8 14.8571C8.54225 14.8571 6.8 12.4743 6.8 8C6.8 3.52571 8.54225 1.14286 9.8 1.14286C11.0578 1.14286 12.8 3.52571 12.8 8ZM5.6105 7.42857L3.2105 7.42857C3.257 6.07143 3.467 4.92857 3.77225 4L6.12125 4C5.80811 5.11938 5.63664 6.27041 5.6105 7.42857ZM5.6105 8.57143C5.63664 9.72959 5.80811 10.8806 6.12125 12L3.773 12C3.46775 11.0714 3.25775 9.92857 3.21125 8.57143L5.6105 8.57143ZM6.2 1.14286L7.58525 1.14286C7.27182 1.50247 7.00421 1.89616 6.788 2.31571C6.69725 2.48929 6.61175 2.67286 6.53075 2.85714L4.25 2.85714C4.838 1.72643 5.57825 1.14286 6.2 1.14286ZM4.25 13.1429L6.53075 13.1429C6.61175 13.3293 6.69725 13.5107 6.788 13.6843C7.00421 14.1038 7.27182 14.4975 7.58525 14.8571L6.2 14.8571C5.57825 14.8571 4.838 14.2736 4.25 13.1429Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default CoinIconFilled;
